module.exports = __webpack_public_path__ + "static/media/sass.380e22e3.png";